<template>
  <div class="index_container">
    <div class="carousel">
      <el-carousel :interval="3000">
        <el-carousel-item v-for="(item, index) in imageList" :key="index">
          <img :src="item.imgSrc" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="recruitmentList">
      <div class="recItem" v-for="(item, index) in reclist" :key="index">
        <div class="title" @click="gorecruitmentList(item.title)">
          <div class="imgwapper"><img :src="item.imgSrc" /></div>
          <div class="itemTitle">{{ item.title }}</div>
          <div :class="'right ' + (item.title === '社会招聘' ? 'red' : '')">
            更多 >
          </div>
        </div>
        <div class="list" v-if="item.data.length">
          <div
            class="list_item"
            v-for="(ele, i) in item.data"
            :key="i"
            @click="goDetail(ele.id)"
          >
            <span class="circle"></span>
            <span class="name">{{ ele.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'indexPage',
  data() {
    return {
      imageList: [
        { imgSrc: require('../assets/image/img1.jpg') },
        { imgSrc: require('../assets/image/img2.jpg') },
        { imgSrc: require('../assets/image/img3.jpg') },
      ],
      reclist: [
        {
          title: '社会招聘',
          imgSrc: require('../assets/image/hot.png'),
          data: [],
        },
        {
          title: '校园招聘',
          imgSrc: require('../assets/image/new.png'),
          data: [],
        },
      ],
      tableDataSocial: [],
      tableDatacampus: [],
    };
  },
  watch: {
    tableDataSocial() {
      this.tableDataSocial.forEach(item => {
        if (this.reclist[0].data.length >= 5) return;
        this.reclist[0].data.push({
          title: item.position,
          id: item.id,
        });
      });
    },
    tableDatacampus() {
      this.tableDatacampus.forEach(item => {
        if (this.reclist[1].data.length >= 5) return;
        this.reclist[1].data.push({
          title: item.position,
          id: item.id,
        });
      });
    },
  },
  created() {
    this.queryTableData('1');
    this.queryTableData('2');
  },
  methods: {
    //跳列表页
    gorecruitmentList(params) {
      let code = 0;
      if (params === '社会招聘') {
        code = 2;
      } else if (params === '校园招聘') {
        code = 1;
      }
      this.$router.push({ name: 'RecruitmentList', query: { type: code } });
    },
    //跳详情
    goDetail(val) {
      this.$router.push({
        name: 'recruitmentDetail',
        query: {
          id: val,
        },
      });
    },
    //招聘数据请求
    queryTableData(params) {
      axios
        .post('/api/recruit/list', {
          body: {
            recruitQuery: {
              position: '',
              recruitType: params,
            },
            page: {
              pageSize: 10,
              pageNumber: 1,
            },
          },
        })
        .then(res => {
          if (res.data.body.list.length) {
            if (params === '2') {
              this.tableDataSocial = res.data.body.list;
            } else if (params === '1') {
              this.tableDatacampus = res.data.body.list;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss">
.index_container {
  .carousel {
    height: 540px;
    .el-carousel {
      height: 100%;
      .el-carousel__container {
        height: 100%;
      }
      img {
        height: 100%;
      }
    }
  }
  .recruitmentList {
    height: calc(100% - 540px);
    margin: 0 300px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    .recItem {
      width: 430px;
      .title {
        cursor: pointer;
        width: 100%;
        position: relative;
        display: flex;
        .imgwapper {
          width: 64px;
          height: 64px;
          line-height: 53px;
          text-align: center;
          border-radius: 100%;
          background-color: #6f5014;
        }
        .itemTitle {
          height: 64px;
          line-height: 64px;
          margin-left: 20px;
        }
        .right {
          height: 64px;
          line-height: 64px;
          position: absolute;
          right: 30%;
          color: #47d0ad;
        }
        .red {
          color: #fb6f4f;
        }
      }
      .list {
        .list_item {
          text-align: left;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #777777;
          margin: 5px;
          cursor: pointer;
          &:hover .circle {
            background: #6f5014;
          }
          .circle {
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 100%;
            border: 1px solid #6f5014;
            margin-right: 5px;
            vertical-align: middle;
          }
          .name {
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>
